import {
    Component,
    OnChanges,
    Input,
    OnInit,
    SimpleChanges,
    Output,
    EventEmitter,
    HostListener,
} from '@angular/core';

@Component({
    selector: 'app-page-list',
    templateUrl: './page-list.component.html',
    styleUrls: ['./page-list.component.scss'],
    standalone: false,
})
export class PageListComponent implements OnInit, OnChanges {
    @Output() onPageSelected: EventEmitter<number> = new EventEmitter<number>();
    @Output() currentPageChange = new EventEmitter<number>();

    @Input() pages: number = 1;
    @Input() displayedPageLimit: number = 7;
    @Input() currentPage = 1;

    pagesToShow: number[] = [];

    alwaysShowLast: Boolean = true;
    alwaysShowFirst: Boolean = true;

    ngOnInit(): void {
        this.calculateDisplayedPages();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.currentPage) {
            this.currentPage++;
        }

        this.calculateDisplayedPages();
    }

    selectPage(pageNumber) {
        if (pageNumber < 1 || pageNumber > this.pages) return;

        this.onPageSelected.emit(pageNumber - 1); //0 Indexed

        this.currentPage = pageNumber;
        this.calculateDisplayedPages();

        this.currentPageChange.emit(this.currentPage - 1);
    }

    calculateDisplayedPages() {
        if (this.pages < 1) this.pages = 1;

        if (this.displayedPageLimit === 1) {
            this.alwaysShowFirst = false;
            this.alwaysShowLast = false;
        } else {
            this.alwaysShowFirst = true;
            this.alwaysShowLast = true;
        }

        const calculatedStartIndex = this.currentPage - Math.ceil(this.displayedPageLimit / 2);
        let startIndex = Math.max(0, calculatedStartIndex);

        const calculatedEndIndex = startIndex + this.displayedPageLimit;
        const endIndex = Math.min(this.pages, calculatedEndIndex);

        if (endIndex < calculatedEndIndex)
            startIndex = Math.max(0, startIndex - (calculatedEndIndex - endIndex));

        this.pagesToShow = [];

        for (let i = startIndex; i < endIndex; i++) {
            this.pagesToShow.push(i + 1);
        }

        if (this.pagesToShow.length <= 3) {
            this.alwaysShowFirst = false;
            this.alwaysShowLast = false;
            return
        }

        if (this.shouldPrependFirstPage()) {
            this.pagesToShow = this.pagesToShow.slice(2, this.pagesToShow.length);
        }

        if (this.shouldAppendLastPage()) {
            this.pagesToShow = this.pagesToShow.slice(0, this.pagesToShow.length - 2);
        }
    }

    @HostListener('window:resize')
    handleWindowResize() {
        this.calculateDisplayedPages();
    }

    shouldPrependFirstPage(): Boolean {
        return this.alwaysShowFirst && this.pagesToShow[0] != 1;
    }

    shouldAppendLastPage(): Boolean {
        return this.alwaysShowLast && this.pagesToShow[this.pagesToShow.length - 1] != this.pages;
    }
}
